import OnestockExistingHoldingContainer from "./OnestockExistingHoldingContainer";
import OnestockExistingHoldingStore from "./OnestockExistingHoldingStore";

export default OnestockExistingHoldingStore(OnestockExistingHoldingContainer);